module.exports = __webpack_public_path__ + "img/1.58edda4d.png";